import React, { useState } from 'react';
import { Link } from 'react-router-dom'; // Import Link

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  return (
    <header className="bg-gradient-to-r from-blue-600 to-teal-500 text-white p-4 sticky top-0 z-50 shadow-lg">
      <div className="container mx-auto flex justify-between items-center">
        <div className="text-2xl font-bold tracking-wide">Episurveillance Kenya - Digital Health Hub</div>
        <button
          className="md:hidden flex flex-col gap-1.5"
          aria-label="Toggle menu"
          aria-expanded={isMenuOpen}
          onClick={toggleMenu}
        >
          <span className={`w-6 h-0.5 bg-white transition-all duration-300 ${isMenuOpen ? 'rotate-45 translate-y-2' : ''}`}></span>
          <span className={`w-6 h-0.5 bg-white transition-all duration-300 ${isMenuOpen ? 'opacity-0' : ''}`}></span>
          <span className={`w-6 h-0.5 bg-white transition-all duration-300 ${isMenuOpen ? '-rotate-45 -translate-y-2' : ''}`}></span>
        </button>
        <nav
          className={`${
            isMenuOpen ? 'block' : 'hidden'
          } md:flex absolute md:static top-16 left-0 w-full md:w-auto bg-gradient-to-r from-blue-600 to-teal-500 md:bg-transparent p-4 md:p-0 transition-all duration-300`}
          aria-label="Main navigation"
        >
          <ul className="flex flex-col md:flex-row space-y-4 md:space-y-0 md:space-x-6">
            {['Services', 'Publications', 'Activities', 'Impact', 'Future', 'About', 'Contact'].map((item, index) => (
              <li key={index}>
                <Link
                  to={{ pathname: "/", hash: `#${item.toLowerCase()}` }}
                  className="hover:text-teal-200 transition-colors duration-200 font-medium"
                >
                  {item}
                </Link>
              </li>
            ))}
            <li>
              <Link to="/login" className="hover:text-teal-200 transition-colors duration-200 font-medium">
                Login
              </Link>
            </li>
          </ul>
        </nav>
      </div>
    </header>
  );
};

export default Header;